import { render, staticRenderFns } from "./CandidateReviewUndo.vue?vue&type=template&id=f88c8ea2&scoped=true"
import script from "./CandidateReviewUndo.vue?vue&type=script&setup=true&lang=js"
export * from "./CandidateReviewUndo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CandidateReviewUndo.vue?vue&type=style&index=0&id=f88c8ea2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88c8ea2",
  null
  
)

export default component.exports